import { configureStore } from '@reduxjs/toolkit';
import textChunkerReducer from './Tools/PostSplitter/textChunkerSlice';
import sentimentSlice from './Tools/Sentiment/SentimentSlice';
import hashtagsSlice from './Tools/Hashtags/HashtagsSlice'
import emojisSlice from './Tools/Emojis/EmojisSlice';
import aiTextDetectorSlice from './Tools/DetectAI/AITextDetectorSlice';
import readabilitySlice from './Tools/ReadabilityChecker/ReadabilitySlice';
import textSummarizationSlice from './Tools/Summarization/TextSummarizationSlice';
import keywordExtractionSlice from './Tools/KeywordExtraction/KeywordExtractionSlice';
import semanticSimilaritySlice from './Tools/SemanticSimilarity/SemanticSimilaritySlice';
import humanizerSlice from './Tools/Humanizer/HumanizerSlice';
import repurposerSlice from './Tools/Repurposer/RepurposerSlice';
import simplifierSlice from './Tools/Simplifier/SimplifierSlice';
import seoSlice from './Tools/SEO/SEOSlice';
import quoteSlice from './Tools/QuoteCard/QuoteSlice';
import flashcardSlice from './Tools/Flashcards/FlashcardSlice';

export const store = configureStore({
  reducer: {
    textChunker: textChunkerReducer,
    textSentiment: sentimentSlice,
    hashtagsAnalyzer: hashtagsSlice,
    emojisSlice: emojisSlice,
    aiTextDetectorSlice: aiTextDetectorSlice,
    readabilitySlice: readabilitySlice,
    textSummarizationSlice: textSummarizationSlice,
    keywordExtraction: keywordExtractionSlice,
    semanticSimilarity: semanticSimilaritySlice,
    humanizerSlice: humanizerSlice,
    repurposerSlice: repurposerSlice,
    simplifierSlice: simplifierSlice,
    seoSlice: seoSlice,
    quoteSlice: quoteSlice,
    flashcardSlice: flashcardSlice,
  },
});
